export const getCellSectionDecoratorStyle = (components, { palette = {} } = {}) => ({
  cellSelectionDecorator: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },

  cellSelectionDecoratorWrapper: {
    width: '100%',
    height: '100%',

    '& .selected-checkbox': {
      position: 'absolute',
      top: 6,
      right: 6,
    },
  },

  selectedState: {
    outlineStyle: 'solid',
    outlineWidth: 4,
    outlineColor: palette.themePrimary,
    borderRadius: 6,
  },
});
